module.exports = __webpack_public_path__ + "static/media/muestrahydrafusion.bb69b03d.png";